import clsx from 'clsx';
import { OrderSaleTab } from '../type';
import styles from '../product-timeline.module.scss';

const SkeletonView: React.FC<{
  loading?: boolean;
  isLoadingSale?: boolean;
  isLoadingOrder?: boolean;
  currentTab?: OrderSaleTab;
}> = ({ loading, isLoadingSale, isLoadingOrder, currentTab }) => {
  if ((currentTab === 'Sale' && isLoadingSale === false) || (currentTab === 'Order' && isLoadingOrder === false)) {
    return <div className={styles.ordersSales__mainRight__noItems} />;
  }
  return (
    <div className={styles.ordersSales__mainRight__skeleton}>
      <div
        className={clsx(
          loading ? styles['ordersSales__mainRight__skeleton--loading'] : '',
          styles['ordersSales__mainRight__skeleton--top'],
        )}
      />
      <div
        className={clsx(
          loading ? styles['ordersSales__mainRight__skeleton--loading'] : '',
          styles['ordersSales__mainRight__skeleton--middle'],
        )}
      />
      <div
        className={clsx(
          loading ? styles['ordersSales__mainRight__skeleton--loading'] : '',
          styles['ordersSales__mainRight__skeleton--middle'],
        )}
      />
      <div
        className={clsx(
          loading ? styles['ordersSales__mainRight__skeleton--loading'] : '',
          styles['ordersSales__mainRight__skeleton--bottom'],
        )}
      />
    </div>
  );
};

export default SkeletonView;
